import { createEffect, createSignal, onCleanup, type Accessor } from "solid-js";
import type { PhosphorIcon } from "@/components/ui/Icon";

export interface WorkspaceCrumb {
  label: string;
  href?: string;
}

export interface WorkspacePageMeta {
  title: string;
  section: string;
  description?: string;
  icon?: PhosphorIcon;
  breadcrumbs?: WorkspaceCrumb[];
  pathname?: string;
}

const [pageMeta, setPageMeta] = createSignal<WorkspacePageMeta | null>(null);

export function workspacePageMeta() {
  return pageMeta();
}

export function setWorkspacePageMeta(meta: WorkspacePageMeta | null) {
  setPageMeta(meta ? { ...meta, pathname: window.location.pathname } : null);
}

export function useWorkspacePageMeta(meta: Accessor<WorkspacePageMeta | null | undefined>) {
  createEffect(() => {
    setWorkspacePageMeta(meta() ?? null);
  });

  onCleanup(() => setWorkspacePageMeta(null));
}

